/**
 * Returns true if a each individual character of a given input passed as string are all natural numbers,
 * false otherwise.
 */
export const areAllNaturalNumbers = (value: string): boolean => {
	return value.split('').every((c) => !isNaN(parseInt(c, 10)));
};
